/**
 * @generated SignedSource<<ffad54f432cdffef3bc3c8dc431ff9a2>>
 * @relayHash a2be411b1772244feef74a2765f2ac57
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8df3009a9d79522bd8efe037cb70fe5c72987241726fa1580e2f0eb97ceb9c96

import type { ConcreteRequest, Query } from 'relay-runtime';
export type ContainerType = "BLOGPOST" | "DATABASE" | "PAGE" | "SPACE" | "WHITEBOARD" | "%future added value";
export type GraphQLReactionContentType = "BLOGPOST" | "COMMENT" | "PAGE" | "%future added value";
export type ReactedUsersQuery$variables = {
  containerId: string;
  containerType: ContainerType;
  contentId: string;
  contentType: GraphQLReactionContentType;
  emojiId: string;
};
export type ReactedUsersQuery$data = {
  readonly reactedUsers: {
    readonly confluencePerson: ReadonlyArray<{
      readonly accountId: string | null | undefined;
      readonly displayName: string | null | undefined;
      readonly profilePicture: {
        readonly path: string;
      } | null | undefined;
    } | null | undefined>;
    readonly count: number;
    readonly emojiId: string;
    readonly reacted: boolean;
  } | null | undefined;
};
export type ReactedUsersQuery = {
  response: ReactedUsersQuery$data;
  variables: ReactedUsersQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "containerId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "containerType"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentType"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "emojiId"
},
v5 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "containerId",
        "variableName": "containerId"
      },
      {
        "kind": "Variable",
        "name": "containerType",
        "variableName": "containerType"
      },
      {
        "kind": "Variable",
        "name": "contentId",
        "variableName": "contentId"
      },
      {
        "kind": "Variable",
        "name": "contentType",
        "variableName": "contentType"
      },
      {
        "kind": "Variable",
        "name": "emojiId",
        "variableName": "emojiId"
      }
    ],
    "concreteType": "ReactedUsersResponse",
    "kind": "LinkedField",
    "name": "reactedUsers",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "count"
      },
      {
        "kind": "ScalarField",
        "name": "emojiId"
      },
      {
        "kind": "ScalarField",
        "name": "reacted"
      },
      {
        "concreteType": "ConfluencePerson",
        "kind": "LinkedField",
        "name": "confluencePerson",
        "plural": true,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "accountId"
          },
          {
            "kind": "ScalarField",
            "name": "displayName"
          },
          {
            "concreteType": "Icon",
            "kind": "LinkedField",
            "name": "profilePicture",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "path"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "ReactedUsersQuery",
    "selections": (v5/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "ReactedUsersQuery",
    "selections": (v5/*: any*/)
  },
  "params": {
    "cacheID": "a2be411b1772244feef74a2765f2ac57",
    "id": "8df3009a9d79522bd8efe037cb70fe5c72987241726fa1580e2f0eb97ceb9c96",
    "metadata": {},
    "name": "ReactedUsersQuery",
    "operationKind": "query",
    "text": "query ReactedUsersQuery($contentId:String!,$containerId:String!,$containerType:ContainerType!,$contentType:GraphQLReactionContentType!,$emojiId:String!){reactedUsers(contentId:$contentId,containerId:$containerId,containerType:$containerType,contentType:$contentType,emojiId:$emojiId){count,emojiId,reacted,confluencePerson{accountId,displayName,profilePicture{path}}}}"
  }
};
})();

(node as any).hash = "c015b4e131a157a2b697f6c2a7cdf8e3";

export default node;
